// @flow

import React, { Fragment } from 'react';

type Props = {
  type: string,
  color: string,
  size: string,
  wrapperClass: ?string
}

const renderIcon = (type: string) => {
  switch (type) {
    case 'T1':
      return (
        <Fragment>
          <polygon points="4,15 11,15 11,39 17,39 17,15 24,15 24,9 4,9" />
          <polygon points="30,9 30,15 36,15 36,39 42,39 42,15 42,9" />
        </Fragment>
      );
    case 'T2':
      return (
        <Fragment>
          <polygon points="3,15 10,15 10,39 16,39 16,15 23,15 23,9 3,9" />
          <path d="M39,27c3.313,0,6-2.687,6-6v-6c0-3.313-2.687-6-6-6H27v6h12v6h-6c-3.313,0-6,2.687-6,6v6v6h18v-6H33v-6H39z" />
        </Fragment>
      );
    case 'SWIMMING':
      return (
        <path
          id="Combined-Shape"
          d="M35.998,24C33.792,24,32,22.21,32,20s1.792-4,3.998-4C38.21,16,40,17.79,40,20S38.21,24,35.998,24z
          M46,24c1.105,0,2,0.895,2,2s-0.895,2-2,2c-2.1,0-3.036,0.678-4.324,1.618C40.216,30.68,38.398,32,35,32
          c-3.402,0-5.216-1.32-6.676-2.382C27.034,28.678,26.098,28,24,28c-2.098,0-3.03,0.678-4.32,1.618C18.218,30.678,16.402,32,13,32
          c-3.398,0-5.214-1.32-6.676-2.382C5.034,28.678,4.098,28,2,28c-1.106,0-2-0.895-2-2s0.894-2,2-2c3.398,0,5.216,1.32,6.678,2.382
          C9.968,27.322,10.902,28,13,28c2.102,0,3.036-0.68,4.326-1.62C18.788,25.32,20.602,24,24,24c0.032,0,0.058,0.004,0.088,0.004
          l-3.044-5.578l-10.412,3.47c-1.058,0.354-2.178-0.216-2.528-1.264c-0.35-1.046,0.216-2.18,1.264-2.528l12-4
          c0.922-0.308,1.924,0.088,2.388,0.938l5.736,10.519c0.43,0.275,0.818,0.558,1.184,0.821C31.964,27.322,32.9,28,35,28
          c2.098,0,3.034-0.678,4.324-1.618C40.784,25.32,42.6,24,46,24z" />
      );
    case 'CYCLING':
      return (
        <path
          id="Combined-Shape"
          d="M24,38c-1.106,0-2-0.895-2-2v-8.764l-6.894-3.446c-0.542-0.27-0.93-0.77-1.06-1.36
          c-0.128-0.59,0.014-1.208,0.392-1.68l8-10c0.426-0.532,1.092-0.806,1.772-0.738c0.679,0.07,1.274,0.484,1.58,1.094L29.236,18H34
          c1.105,0,2,0.894,2,2s-0.895,2-2,2h-6c-0.758,0-1.45-0.428-1.79-1.106l-2.6-5.204l-4.504,5.628l5.789,2.892
          C25.57,24.55,26,25.242,26,26v10C26,37.105,25.105,38,24,38z M36,8c0,2.208-1.792,4-4,4s-4-1.792-4-4s1.792-4,4-4S36,5.792,36,8z
          M9,44c-4.964,0-9-4.038-9-9s4.036-9,9-9c4.962,0,9,4.038,9,9S13.962,44,9,44z M39,44c-4.964,0-9-4.038-9-9s4.036-9,9-9
          c4.962,0,9,4.038,9,9S43.962,44,39,44z M9,30c-2.758,0-5,2.242-5,5s2.242,5,5,5s5-2.242,5-5S11.758,30,9,30z M39,30
          c-2.758,0-5,2.242-5,5s2.242,5,5,5s5-2.242,5-5S41.758,30,39,30z" />
      );
    case 'RUNNING':
      return (
        <path
          id="Combined-Shape"
          d="M23.902,26.926L31.2,32.4c0.464,0.35,0.754,0.879,0.794,1.457c0.042,0.58-0.17,1.146-0.58,1.557l-8,8
          C23.024,43.805,22.512,44,22,44s-1.024-0.195-1.414-0.586c-0.782-0.782-0.782-2.046,0-2.828l6.37-6.37l-5.912-4.433L7.414,43.414
          C7.024,43.805,6.512,44,6,44s-1.024-0.195-1.414-0.586c-0.782-0.782-0.782-2.046,0-2.828l24.37-24.37l-4.768-3.576l-6.774,6.774
          c-0.782,0.782-2.046,0.782-2.828,0c-0.782-0.782-0.782-2.046,0-2.828l8-8C23.288,7.878,24.402,7.798,25.2,8.4l8,6
          c0.464,0.35,0.754,0.88,0.794,1.458c0.042,0.58-0.17,1.146-0.58,1.556L23.902,26.926z M42,28H32c-1.105,0-2-0.895-2-2s0.895-2,2-2
          h10c1.105,0,2,0.895,2,2S43.105,28,42,28z M42,8c0,2.212-1.796,4-4,4c-2.212,0-4-1.788-4-4c0-2.208,1.788-4,4-4
          C40.204,4,42,5.792,42,8z" />
      );
    case 'distance':
      return (
        <path
          d="M42.852,33.924l-6.15-22C36.218,10.195,34.643,9,32.846,9H26v6c0,1.104-0.896,2-2,2s-2-0.896-2-2V9h-7.301
          c-1.825,0-3.418,1.233-3.875,2.998l-5.696,22C5.043,34.325,5,34.662,5,35c0,2.209,1.792,4,4.003,4H24c-1.104,0-2-0.896-2-2V25
          c0-1.104,0.896-2,2-2s2,0.896,2,2v12c0,1.104-0.896,2-2,2h14.995c0.364,0,0.727-0.05,1.077-0.147
          C42.201,38.258,43.446,36.052,42.852,33.924z" />
      );
    case 'pace':
      return (
        <path
          id="Clip-2"
          d="M43.553,37.562c-0.122,0.864-0.452,1.649-0.938,2.313c-0.458,0.686-1.109,1.23-1.846,1.586
          c-1.449,0.725-3.237,0.777-4.938-0.205L13.681,28.468c-0.693-0.4-1.256-0.7-1.881-1.032c-1.181-0.661-2.605-1.459-3.513-1.982
          l-0.02-0.012c-3.654-2.109-5.795-3.346-2.963-9.276c0.362-0.716,0.765-1.413,1.272-2.15c0.472-0.702,1.046-1.475,1.781-2.403
          l0.016-0.011l0.878-1.104l0.028-0.049c0.98-1.264,1.97-2.563,3.074-3.687l0.006-0.011c0.254-0.246,0.534-0.438,0.836-0.582
          c0.488-0.19,0.99-0.219,1.528-0.082c0.376,0.118,0.752,0.334,1.088,0.628l0.059,0.083c0.371,0.383,0.667,0.888,0.949,1.453
          l0.035,0.09c0.47,0.982,0.661,1.854,0.839,2.643l0.029,0.126c0.29,1.188,0.604,2.219,1.898,2.966
          c1.092,0.63,2.41,1.053,3.397,1.131l0.208,0.021c-0.11-1.402,0.637-2.448,1.622-3.103c0.362-0.229,0.735-0.406,1.12-0.532
          l0.067-0.021c0.373-0.114,0.775-0.174,1.11-0.18c1.196-0.065,2.206,0.452,2.563,1.53c0.223,0.695,0.686,2.112,1.344,3.875
          c0.42,1.113,0.898,2.363,1.455,3.61c0.744,1.763,1.625,3.52,2.556,5.082c0.7,1.21,1.436,2.246,2.169,2.938l2.34,2.221
          c0.551,0.532,1.047,0.982,1.723,1.597C43.188,33.948,43.773,35.879,43.553,37.562z M28.118,20.774l-7.89,2.146
          c-0.562,0.153-0.895,0.731-0.744,1.294c0,0.002,0.001,0.005,0.002,0.008c0.154,0.556,0.729,0.882,1.285,0.728l8.071-2.234
          L28.118,20.774z M30.338,24.557l-6.116,1.717c-0.562,0.157-0.893,0.738-0.742,1.301c0.002,0.008,0.004,0.016,0.006,0.022
          c0.16,0.546,0.731,0.859,1.277,0.7l6.5-1.898L30.338,24.557z" />
      );
    default:
      return null;
  }
};

const StageIcon = ({
  type, color, size, wrapperClass,
}: Props) => {
  return (
    <div className={wrapperClass}>
      {
        type
          ? <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 48 48"
            enableBackground="new 0 0 48 48">
            <g fill={color}>
              {renderIcon(type)}
            </g>
          </svg> : null
      }
    </div>
  );
};

export default StageIcon;
